import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      cx: "9.02211",
      cy: "7.97266",
      rx: "8.06556",
      ry: "7.93925",
      transform: "rotate(0.629221 9.02211 7.97266)",
      fill: "#01BC45",
      "fill-opacity": "0.87"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.77 4.84314C13.1539 5.14186 13.2257 5.69889 12.9304 6.08723L9.08016 11.3129C8.93472 11.5041 8.71855 11.6272 8.48147 11.6537C8.24439 11.6803 8.00685 11.608 7.8236 11.4535L5.42786 9.47357C5.05578 9.15992 5.0055 8.60047 5.31558 8.22409C5.62565 7.84771 6.17864 7.79685 6.55073 8.1105L8.24592 9.49987L11.5401 5.00541C11.8354 4.61707 12.3861 4.54442 12.77 4.84314Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }